import React from "react";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <footer className="footer-system" style={{ padding: '40px 20px 20px 20px', fontFamily: 'Arial, sans-serif', width: '100%', boxSizing: 'border-box' }}>
      
      {/* Mobile Responsive Style Layer */}
      <style>{`
        @media (max-width: 480px) {
          .footer-system {
            padding: 30px 15px 15px 15px !important;
          }
          .feedback-wrap-box {
            flex-wrap: wrap !important;
            white-space: normal !important;
          }
          .links-grid-system {
            grid-template-columns: 1fr !important;
            gap: 10px !important;
          }
          .footer-disclaimer-box p {
            text-align: left !important;
          }
        }
      `}</style>
      
      {/* PERFECTLY ALIGNED GRID SYSTEM FOR DESKTOP & MOBILE */}
      <div className="footer-columns" style={{ 
        display: 'grid', 
        gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', 
        gap: '40px', 
        alignItems: 'start',
        width: '100%'
      }}>
        
        {/* COL 1: Corporate Profile & Feedback */}
        <div className="footer-col connect-col">
          <h4 className="footer-heading" style={{ fontSize: '1.2rem', fontWeight: '700', marginBottom: '15px' }}>
            Medical Trip World
          </h4>
          <p style={{ fontSize: '0.9rem', lineHeight: '1.6', marginBottom: '20px', opacity: 0.85 }}>
            Your trusted pathway to global healthcare options. Helping international patients research independent private medical benchmarks securely.
          </p>
          
          {/* FORCED SINGLE LINE SYSTEM */}
          <div className="feedback-wrap-box" style={{ display: 'flex', alignItems: 'center', gap: '6px', whiteSpace: 'nowrap', flexWrap: 'nowrap' }}>
            <span style={{ fontSize: '0.9rem', fontWeight: 'bold' }}>Share Feedback:</span>
            <a href="mailto:medicaltripworld@gmail.com" className="tile-icon icon-edit" style={{ 
              textDecoration: 'none', 
              fontSize: '0.9rem', 
              display: 'inline-flex', 
              alignItems: 'center',
              gap: '4px',
              color: 'inherit',
              whiteSpace: 'nowrap'
            }}>
               <span style={{ borderBottom: '1px solid currentColor' }}>📧</span>
            </a>
          </div>
        </div>

        {/* COL 2: Useful Links */}
        <div className="footer-col links-col">
          <h4 className="footer-heading" style={{ fontSize: '1.2rem', fontWeight: '700', marginBottom: '15px' }}>
            Useful Links
          </h4>
          <div className="links-grid-system" style={{ 
            display: 'grid', 
            gridTemplateColumns: '1fr 1fr', 
            gap: '12px 20px', 
            fontSize: '0.9rem' 
          }}>
            <Link to="/analytics" style={{ textDecoration: 'none', color: 'inherit' }}>Visitor Analytics</Link>
            <Link to="/help" style={{ textDecoration: 'none', color: 'inherit' }}>Help</Link>
            <Link to="/faq" style={{ textDecoration: 'none', color: 'inherit' }}>FAQs</Link>
            <Link to="/terms" style={{ textDecoration: 'none', color: 'inherit' }}>Terms & Conditions</Link>
            <Link to="/library" style={{ textDecoration: 'none', color: 'inherit' }}>Library</Link>
            <Link to="/policies" style={{ textDecoration: 'none', color: 'inherit' }}>Website Policies</Link>
            <Link to="/sitemap" style={{ textDecoration: 'none', color: 'inherit' }}>Sitemap</Link>
          </div>
        </div>

        {/* COL 3: Contact Us */}
        <div className="footer-col contact-col">
          <h4 className="footer-heading" style={{ fontSize: '1.2rem', fontWeight: '700', marginBottom: '15px' }}>
            Contact Us
          </h4>
          <div className="contact-info-block" style={{ display: 'flex', flexDirection: 'column', gap: '14px', lineHeight: '1.5', fontSize: '0.9rem' }}>
            
            {/* Address */}
            <div style={{ display: 'flex', gap: '10px', alignItems: 'flex-start' }}>
              <span style={{ fontSize: '1.1rem', flexShrink: 0 }}>📍</span>
              <p style={{ margin: 0 }}>
                Medical Trip World Head Office, Kishangarh, New Delhi - 110070, India
              </p>
            </div>

            {/* Voice Call */}
            <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
              <span style={{ fontSize: '1.1rem', flexShrink: 0 }}>📞</span>
              <a href="tel:+916205355169" style={{ color: 'inherit', textDecoration: 'none' }}>
                +91 6205355169 (Voice Call)
              </a>
            </div>

            {/* WhatsApp */}
            <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
              <span style={{ fontSize: '1.1rem', flexShrink: 0 }}>💬</span>
              <a href="https://wa.me/916205355169" target="_blank" rel="noopener noreferrer" style={{ color: 'inherit', textDecoration: 'none', fontWeight: 'bold' }}>
                +91 6205355169 (WhatsApp Desk)
              </a>
            </div>

            {/* Emails */}
            <div style={{ display: 'flex', gap: '10px', alignItems: 'flex-start' }}>
              <span style={{ fontSize: '1.1rem', marginTop: '2px', flexShrink: 0 }}>✉️</span>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', minWidth: 0 }}>
                <a href="mailto:support@medicaltripworld.com" style={{ color: 'inherit', textDecoration: 'none', wordBreak: 'break-all' }}>
                  support@medicaltripworld.com
                </a>
                <a href="mailto:medicaltripworld@gmail.com" style={{ color: 'inherit', textDecoration: 'none', wordBreak: 'break-all', opacity: 0.85 }}>
                  medicaltripworld@gmail.com
                </a>
              </div>
            </div>

          </div>
        </div>
      </div>

      {/* GLOBAL LEGAL & MEDICAL DISCLAIMER STRIP */}
      <div className="footer-disclaimer-box" style={{ borderTop: "1px solid #333", marginTop: "35px", paddingTop: "20px", fontSize: "0.8rem", color: "#aaa", lineHeight: "1.6", textAlign: "justify" }}>
        <p style={{ margin: 0 }}>
          <strong>Disclaimer:</strong> Medical Trip World is an independent informational directory and patient facilitation platform. We do not provide medical advice, diagnosis, or treatment. Medical Trip World is not an official representative of, nor does it have an exclusive legal partnership or MOU with any specific hospital network. All hospital names, logos, costs, and clinical data displayed are gathered from publicly available records and industry research for educational purposes only. Patients are strictly advised to independently verify all hospital accreditations, surgeon credentials, and final treatment costs directly with the healthcare provider before making any medical travel decisions.
        </p>
      </div>
    </footer>
  );
}

export default Footer;